import { logWrapper } from '../../utils';

export default {
  reportController: [
    'runtimeConstant',
    '$rootScope',
    'webApiSettings',
    function (runtimeConstant, $rootScope, webApiSettings) {
      'use strict';

      function run() {
        try {
          $rootScope.menus = [
            {
              title: 'DASHBOARD',
              icon: 'md md-my-library-books',
              ref: 'modules.reports.dashboard',
              visible: () => true,
              features: [],
              enabled: true,
              new: false,
            },

            {
              title: 'AUDIT USER',
              icon: 'md md-my-library-books',
              ref: 'modules.reports.auditUser',
              visible: () => true,
              features: [],
              enabled: true,
              new: false,
            },

            {
              title: 'ADDITIONAL FIELDS',
              icon: 'md md-my-library-books',
              ref: 'modules.reports.additionalFields',
              visible: () => true,
              features: [],
              enabled: true,
              new: false,
            },

            {
              title: 'PENDING SUBSCRIPTION',
              icon: 'icon-certificata',
              ref: 'modules.reports.pendingSubscription',
              visible: () => true,
              features: [],
              enabled: true,
              new: true,
            },

            {
              title: 'INVENTORY',
              icon: 'md md-my-library-books',
              ref: 'modules.reports.inventory',
              visible: () => true,
              features: [],
              enabled: true,
              new: false,
            },

            {
              title: 'ACTIVE PUBLIC LINK',
              icon: 'md md-my-library-books',
              ref: 'modules.reports.publicLink',
              visible: () => true,
              features: [],
              enabled: true,
              new: true,
            },

            {
              title: 'INDEXED PAGES',
              icon: 'md md-my-library-books',
              ref: 'modules.reports.indexedPages',
              visible: () => true,
              features: [],
              enabled: true,
              new: false,
            },

            {
              title: 'UN/ACTIVE USERS',
              icon: 'md md-my-library-books',
              ref: 'modules.reports.activeUsers',
              visible: () => true,
              features: [],
              enabled: true,
              new: false,
            },

            {
              title: 'DOCUMENTS EXPIRATION',
              icon: 'md md-my-library-books',
              ref: 'modules.reports.expiredRevisions',
              visible: () => true,
              features: [],
              enabled: true,
              new: false,
            },

          ];

          if (webApiSettings.detailsCompany !== 'abase') {
            $rootScope.menus.push({
              title: 'SHARED FOLDERS',
              icon: 'md md-my-library-books',
              ref: 'modules.reports.sharedFolders',
              visible: () => true,
              features: [],
              enabled: true,
              new: false,
            });
          }
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
